import go from 'abbot-core';
import data from './data';

go(data);



// WEBPACK FOOTER //
// ./src/index.js